export const V1_SET_ARRIVAL_AIRPORT = 'V1_SET_ARRIVAL_AIRPORT'

export default data => {
  return {
    type: V1_SET_ARRIVAL_AIRPORT,
    data,
  }
}
